import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AnyObject, UnauthorizedHourData} from "@mri/types";

function newItem(): UnauthorizedHourData {
    return {
        days: [1, 2, 3, 4, 5],
        starHour: '06:00',
        endHour: '10:00',
        timezone: '+05:00'
    }
}

@Component({
    selector: 'app-alarm-field-unauthorized-schedule',
    templateUrl: './alarm-field-unauthorized-schedule.component.html',
    styleUrl: './alarm-field-unauthorized-schedule.component.scss'
})
export class AlarmFieldUnauthorizedScheduleComponent implements OnInit{

    days = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];
    currentValue: Array<UnauthorizedHourData> = [newItem()];

    @Output() valueChange = new EventEmitter<Array<UnauthorizedHourData>>()

    @Input() set value(value: UnauthorizedHourData[]) {
        if (!value) return;
        this.currentValue = value;
    }

    ngOnInit() {
        this._emit()
    }

    onFocusElement(event: AnyObject) {
        event.target.showPicker();
    }

    toggleDay(item: UnauthorizedHourData, day: number){
        if(item.days.includes(day))
            item.days.splice(item.days.indexOf(day), 1);
        else item.days.push(day);
    }

    addHour() {
        this.currentValue.push(newItem());
        this._emit();
    }

    setStartHour(item: UnauthorizedHourData, $event: AnyObject) {
        item.starHour = $event?.target?.value;
        this._emit();
    }

    setEndHour(item: UnauthorizedHourData, $event: AnyObject) {
        item.endHour = $event?.target?.value;
        this._emit();
    }

    setTimezone(item: UnauthorizedHourData, $event: string) {
        item.timezone = $event;
        this._emit();
    }

    removeHour(item: UnauthorizedHourData) {
        const index = this.currentValue.indexOf(item);
        if (index == -1) return;

        this.currentValue.splice(index, 1);
        this._emit();
    }

    private _emit() {
        this.valueChange.emit(this.currentValue)
    }


}
